export const apiUrl = process.env.NODE_ENV === "production" ? "" : "/api"
export const HostUrl = location.origin + "/"
export const staticImgUrl = 'https://www.coolgua.net/match_img'
export const MODE = process.mode
console.log('我的模板', MODE)


let _SDKAppID_IM = ''
let _SDKAppID = ''
if (MODE == 'yiwu') {
  // 义乌
  _SDKAppID = 1400608270
  _SDKAppID_IM = 1400608270
} else if (MODE == '南京中外贸易') {
  _SDKAppID = 1400608270
  _SDKAppID_IM = 1400608270
} else if (MODE == '标准化') {
  _SDKAppID = 1400608270
  _SDKAppID_IM = 1400608270
} else if (MODE == '闻信') {
  if (location.href.indexOf('online.xbwbh.com') > -1) {
    _SDKAppID = 1400766491 // 正式
    _SDKAppID_IM = 1400766491
  } else {
    _SDKAppID = 1400766491 //1400517707; //测式
    _SDKAppID_IM = 1400766491 //1400517707;
  }
} else {
  _SDKAppID = 1400608270 //默认标准化
  _SDKAppID_IM = 1400608270//默认标准化
}

export const SDKAppID = _SDKAppID
export const SDKAppID_IM = _SDKAppID_IM

console.log("SDKAppID,=====>", SDKAppID)



// WEBPACK FOOTER //
// ./src/match/config.js